export enum StatusVersionEnum {
  Upload = 1,
  Capa = 2,
  Material = 3,
  AguardandoPagamento = 4,
  DadosDoLivro = 5,
  RevisaoDaEditora = 6,
  AguardandoAjustesDoAutor = 7,
  AguardandoAprovacaoDoAutor = 8,
  Publicado = 9,
  PublicacaoSuspensa = 10
}